import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useNavigate } from "react-router-dom";

import { useAuthStore } from '@/app/store/auth.store';
import { useMyProfile } from '@/shared/hooks/use-my-profile';
import { useWithdrawPolling } from '@/shared/hooks/use-withdraw-polling';

import { MyInfoCard } from './MyInfoCard';
import { PasswordCard } from './PasswordCard';
import { WithdrawCard } from './WithdrawCard';

export function MedicalMyProfilePage() {
  const { t } = useTranslation('myProfile');
  const navigate = useNavigate();
  const logout = useAuthStore((s) => s.logout);
  const { data: profile, isLoading, isError, refetch } = useMyProfile();

	const handleWithdrawApproved = useCallback(() => {
		logout();
		navigate("/login", { replace: true });
	}, [logout, navigate]);
	useWithdrawPolling(profile, handleWithdrawApproved);

  return (
    <>
      <div className="content__header">
        <h1 className="content__title">{t('title')}</h1>
        <div className="content__subtitle">{t('subtitle')}</div>
      </div>

      <div className="content__body content__body--profile">
        {isLoading ? (
          <div className="card profile-card">
            <div className="card__body">{/* Loading skeleton placeholder */}</div>
          </div>
        ) : isError || !profile ? (
          <div className="card profile-card">
            <div className="card__body">
              <p className="form-field__error">{t('load.error')}</p>
              <button
                type="button"
                className="btn btn--secondary btn--sm"
                onClick={() => refetch()}
              >
                {t('load.retry')}
              </button>
            </div>
          </div>
        ) : (
          <>
            <MyInfoCard profile={profile} />
            <PasswordCard profile={profile} />
            <WithdrawCard profile={profile} />
          </>
        )}
      </div>
    </>
  );
}

export default MedicalMyProfilePage;
